import {svgIconWrapper} from '../svg-icon-wrapper';

import EcologiRegular from './ecologi-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <EcologiRegular {...props} />;
}

SvgComponent.iconName = 'ecologiRegular';

export const EcologiRegularIcon = svgIconWrapper(SvgComponent);
